import {ICON_TYPES} from '../constants';

export const InfoIcon = (): JSX.Element => {
  return (
    <svg
      width='40'
      height='40'
      viewBox='0 0 40 40'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M20 40C16.0444 40 12.1776 38.827 8.8886 36.6294C5.59962 34.4318 3.03617 31.3082 1.52242 27.6537C0.00866572 23.9992 -0.387401 19.9778 0.384303 16.0982C1.15601 12.2186 3.06082 8.65492 5.85787 5.85787C8.65492 3.06082 12.2186 1.15601 16.0982 0.384303C19.9778 -0.387401 23.9992 0.00866572 27.6537 1.52242C31.3082 3.03617 34.4318 5.59962 36.6294 8.8886C38.827 12.1776 40 16.0444 40 20C39.9943 25.3026 37.8853 30.3863 34.1358 34.1358C30.3863 37.8853 25.3026 39.9943 20 40ZM20 3.33334C16.7037 3.33334 13.4813 4.31083 10.7405 6.14218C7.99969 7.97354 5.86348 10.5765 4.60202 13.622C3.34056 16.6674 3.0105 20.0185 3.65359 23.2515C4.29667 26.4845 5.88402 29.4542 8.2149 31.7851C10.5458 34.116 13.5155 35.7033 16.7485 36.3464C19.9815 36.9895 23.3326 36.6595 26.3781 35.398C29.4235 34.1365 32.0265 32.0003 33.8578 29.2595C35.6892 26.5187 36.6667 23.2964 36.6667 20C36.6618 15.5812 34.9043 11.3448 31.7798 8.22025C28.6552 5.0957 24.4188 3.3382 20 3.33334Z'
        fill='#43494F'
      />
      <path
        d='M23.3337 31.6666H20.0003V20H16.667V16.6666H20.0003C20.8844 16.6666 21.7322 17.0178 22.3573 17.6429C22.9825 18.2681 23.3337 19.1159 23.3337 20V31.6666Z'
        fill='#43494F'
      />
      <path
        d='M20 13.3334C21.3807 13.3334 22.5 12.2141 22.5 10.8334C22.5 9.45266 21.3807 8.33337 20 8.33337C18.6193 8.33337 17.5 9.45266 17.5 10.8334C17.5 12.2141 18.6193 13.3334 20 13.3334Z'
        fill='#43494F'
      />
    </svg>
  );
};

InfoIcon.iconType = ICON_TYPES.INFO;
